import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@app/core/model/entities/asset/asset';
import { WorkInput } from '@app/core/model/entities/works/work';
import {
  WorkCreateModalComponent
} from '@app/features/main/views/works/works-inventory/modals/work-create-modal/work-create-modal.component';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { ValidationService } from '@app/shared/services/validation.service';

@Component({
  templateUrl: './asset-work-create-modal.component.html',
  providers: [FormStateService, ValidationService],
  standalone: false
})
export class AssetWorkCreateModalComponent extends WorkCreateModalComponent {
  private readonly asset = inject<{ asset: Asset; }>(MAT_DIALOG_DATA).asset;
  public formId = 'asset_work_creation_dialog';

  /**
   * @return Work data.
   */
  public getGeneratedObject(): WorkInput {
    return {
      ...this.workInput,
      assetId: this.asset.id
    };
  }
}
